import { useEffect } from "react";
import Markdown from "react-markdown";
import { useTermsAndConditionsState } from "../../adapters/insights-agent/state/hooks/stateHooks.ts";
import { useAppName } from "../../adapters/insights-agent/state/hooks/useAppName.ts";
import { useInsightsAgentService } from "../../adapters/insights-agent/state/hooks/useInsightsAgentService.tsx";
import { useConfig } from "../../adapters/insights-agent/state/hooks/useConfig.ts";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks.ts";
import { Header } from "../../feature-components/Header/Header.tsx";
import markdownStyles from "../../ui-library/MarkdownContent.module.css";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

export const TermsAndConditionsPage: React.FC = () => {
  const appService = useInsightsAgentService();
  const { environment } = useConfig();
  const enableGlobalNav = useFeatureFlagValue("enableGlobalNav");

  const termsState = useTermsAndConditionsState();

  useEffect(() => {
    if (!termsState.content) {
      appService.refreshTermsAndConditions({ forceContentLoad: true }).then();
    }
  }, [appService, termsState.content]);
  return (
    <>
      <Header
        isAuthenticated
        enableGlobalNav={enableGlobalNav}
        onLogoutClick={appService.authService.logout}
        env={environment}
        appTitle={useAppName()}
      />
      <div
        style={{ padding: "1rem", maxWidth: 800, margin: "0 auto" }}
        className={markdownStyles.MarkdownContent}
      >
        {termsState.status === "loading" && <p>Loading...</p>}
        {termsState.status === "error" && (
          <p style={{ color: "red" }}>
            Error loading terms and conditions: {termsState.error}
          </p>
        )}
        {/* NOTE: `remarkGfm` is necessary for rendering Github flavoured Markdown Tables. */}
        {termsState.content && (
          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
            {termsState.content}
          </Markdown>
        )}
      </div>
    </>
  );
};
